<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :defaultPageSize="20"
               :pageSizeOptions="[20,50,100]"
               tableApi="admin/user/getFleetDriver"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>

        <FormItem prop="car_number">
          <Input type="text" v-model="searchData.car_number" placeholder="车牌号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="company_id">
          <Select v-model="searchData.company_id" placeholder="所属车队" filterable>
            <Option v-for="item in companys" :value="item.company_id" :key="item.company_id">{{item.company_name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="is_bind">
          <Select v-model="searchData.is_bind" placeholder="是否绑定">
            <Option value="">是否绑定</Option>
            <Option value="1">已绑定</Option>
            <Option value="-1">未绑定</Option>
          </Select>
        </FormItem>

        <!--<FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" placeholder="注册时间" style="width: 320px"></DatePicker>
        </FormItem>-->
      </template>

      <!--<template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>-->

    </pageTable>

    <Modal
            v-model="showChangeModel"
            title="修改车队卡"
            @on-ok="doChange"
            @on-cancel="changeInfo=false">
      <div style="padding: 10px">
        {{changeInfo.mobile}}  {{changeInfo.car_number}} {{changeInfo.user_name}}
      </div>
      <Form ref="changeForm" :model="changeForm">
        <FormItem prop="card_id">
          <Select v-model="changeForm.card_id" placeholder="请选择">
            <Option value="">请选择</Option>
            <Option v-for="item in changeCompanys" :value="item.card_id" :key="item.card_id">{{item.company_name}} {{item.car_number}} {{item.user_name}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'
  export default {
    name: "driver",
    components:{pageTable},
    data() {
      return {
        showEdit:false,
        editUserId:0,     //编辑的用户ID
        searchData: {
          mobile: '',
          nick_name:'',
          company_id:'',
          car_number:'',
          create_time:'',
          is_bind:''
        },
        tableColumn: [
          {title: 'ID',key: 'user_id',width: 80,align: "center"},
          {title: '手机号',key: 'mobile',align: "center"},
          {title: '姓名',key: 'user_name',align: "center"},
          {title: '微信名',key: 'nick_name',align: "center"},
          {title: '车队',key: 'company_name',align: "center"},
          {title: '车牌号',key: 'car_number',align: "center"},
          {title: '注册时间',key: 'create_time',align: "center"},
         {title: '操作',align: "center",width:120,render:(h,params)=>{
            return h('div',[
                h('Button',
                  {
                    props: {type:'primary',size:'small'},
                    on:{
                      click:()=>{this.getFleetDriverCompany(params.row)}
                    },
                  },'更换车队卡')
            ])
            }},
        ],
        tableData: [],
        companys: [],
        changeCompanys:[],
        showChangeModel:false,
        changeInfo:{},
        changeForm:{
          card_id:''
        }
      }
    },
    methods: {
      async getFleetDriverCompany(user_info){
        let data = await this.$commonFun.postProxy('admin/user/getFleetDriverCompany',{user_id:user_info.user_id})
        this.$commonFun.dealApiResult(data,()=>{
          this.changeCompanys = data.data
          this.changeInfo = user_info
          this.showChangeModel = true
        })
      },
      async doChange(){
        let params = {
          user_id:this.changeInfo.user_id,
          card_id:this.changeForm.card_id,
        }
        let res = await this.$commonFun.postProxy('admin/user/changeCardID',params)
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip();
          this.$refs.table.getLists()
        })
      },
      exportData(){
        this.$commonFun.postProxy('admin/user/exportDriver',this.searchData).then((res)=>{
          this.$commonFun.dealApiResult(res,()=>{
            let worksheet = XLSX.utils.aoa_to_sheet(res.data)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`司机列表.xlsx`)
          })
        })
      }
    },
    mounted() {
      this.$commonFun.postProxy('admin/company/getAllCompany',{}).then((res)=>{
        this.companys = res.data
      })
    },
  }
</script>

<style scoped>

</style>
